import React, { useEffect, useState } from 'react'
import { get } from 'helpers/api_helper'
import { levelAnswer } from 'helpers/opponentLevelAnswer'

/** Current effective answer per author for one player, sport and format. */
export function OpponentLevelAnalysis({ playerUserId, sportType, canView }) {
  const [gameType, setGameType] = useState('singles')
  const [page, setPage] = useState(1)
  const [retry, setRetry] = useState(0)
  const [state, setState] = useState({ loading: false, error: false, data: null })
  useEffect(() => { setPage(1) }, [playerUserId, sportType, gameType])
  useEffect(() => {
    if (!canView || !playerUserId || !sportType) return
    let current = true
    setState({ loading: true, error: false, data: null })
    const query = new URLSearchParams({ sportType, gameType, page: String(page), limit: '20' })
    get(`/admin/players/${playerUserId}/opponent-levels?${query}`).then(response => {
      if (current) setState({ loading: false, error: false, data: response.data || null })
    }).catch(() => { if (current) setState({ loading: false, error: true, data: null }) })
    return () => { current = false }
  }, [canView, playerUserId, sportType, gameType, page, retry])
  if (!canView || !playerUserId) return null
  const { data } = state
  return <section aria-label="Opponent level analysis" className="bg-light rounded p-3 mb-3"><details open className="cp-review-section">
    <summary><strong>Opponent level</strong><small className="d-block text-muted">Latest valid opponents and source records · Superadmin only</small></summary><div className="pt-3">
    <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
      <div><h5 className="mb-1">Opponent level analysis</h5><p className="text-muted mb-0">Private player estimates. Review signals do not change the current level.</p></div>
      <label htmlFor="opponent-level-format" className="mb-0">Format
        <select id="opponent-level-format" className="form-control" value={gameType} onChange={event => setGameType(event.target.value)}>
          <option value="singles">Singles</option><option value="doubles">Doubles</option>
        </select>
      </label>
    </div>
    {state.loading && <p role="status">Loading level analysis…</p>}
    {state.error && <div role="alert">Could not load level analysis. <button type="button" className="btn btn-link p-0" onClick={() => setRetry(value => value + 1)}>Retry</button></div>}
    {data && <>
      <p className="mb-1">Current: {data.currentLevel ?? 'Not set'} · Average estimate: {Number.isFinite(data.average) ? data.average.toFixed(1) : '—'} · Numeric authors: {data.numericCount} · Median for signal: {data.median ?? '—'}</p>
      <p className={data.signal ? 'text-warning font-weight-bold' : 'text-muted'}>{data.signal ? 'Review suggested: estimated median differs from the current level.' : 'No review signal.'}</p>
      {data.results.length ? <div className="table-responsive"><table className="table table-striped">
        <thead><tr><th scope="col">Author</th><th scope="col">Effective answer</th><th scope="col">Source</th></tr></thead>
        <tbody>{data.results.map(row => <tr key={row.authorId}><td>#{row.authorId}</td><td>{levelAnswer(row.value)}</td><td>{row.sourceType} · #{row.sourceId}</td></tr>)}</tbody>
      </table></div> : <p>No effective estimates for this sport and format.</p>}
      <div className="d-flex align-items-center gap-10">
        <button type="button" className="btn btn-secondary" disabled={page <= 1} onClick={() => setPage(value => value - 1)}>Previous</button>
        <span>Page {page} · {data.total} authors</span>
        <button type="button" className="btn btn-secondary" disabled={page * 20 >= data.total} onClick={() => setPage(value => value + 1)}>Next</button>
      </div>
    </>}
  </div></details></section>
}

export default OpponentLevelAnalysis
